import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDialog } from '../../components/Dialog/Dialog.styles';
import { StyledDialogBody } from '../../components/DialogBody/DialogBody.styles';
import { spaceMixin } from '../spaceMixin';
import { PopoverMixin } from './PopoverMixin';

/** @class TooltipMixin */
/** @method */
export var TooltipMixin = function TooltipMixin(props) {
  return token({
    dialogBodyPaddingX: 'Tooltip.DialogBody.paddingX',
    dialogBodyPaddingY: 'Tooltip.DialogBody.paddingY'
  }, function (_ref) {
    var dialogBodyPaddingX = _ref.dialogBodyPaddingX,
      dialogBodyPaddingY = _ref.dialogBodyPaddingY;
    return css(["", " ", "{max-height:none;width:auto;&:after{content:none;}}", "", "{padding:", ";&:after{content:none;}}"], PopoverMixin(props), StyledDialog, StyledDialogBody, StyledDialogBody, dialogBodyPaddingX && dialogBodyPaddingY ? dialogBodyPaddingY + "px " + dialogBodyPaddingX + "px" : spaceMixin('xs')(props) + " " + spaceMixin('sm')(props));
  })(props);
};